/**
 * @fileoverview Calendar phase — parent route
 *
 * Purpose: Layout shell for the Calendar phase. Renders an `<Outlet />`
 * so nested sub-routes mount their own page content:
 *
 *   - calendar.index         → /calendar              (Key Dates surface)
 *   - calendar.review-windows → /calendar/review-windows
 *
 * Mirrors the Data (`summaries`) parent layout pattern.
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar",
)({
  component: CalendarLayout,
});

function CalendarLayout() {
  return <Outlet />;
}
